import React, { useState, useEffect, useRef } from 'react';
import HomeInspectionInfo from '../components/Misssection';
import BusinessNeed from '../components/BusinessNeed'
import Interiors from '../components/Interiors';
import TorontoSection from '../components/Toronto';
import ReasonSection from '../components/Reason';
import VideoSection from '../components/Video';
import ReviewSection from '../components/Review';
import AdditionalSection from '../components/Additional';
import Drone from '../components/Drone';
import Commondefects from '../components/Common-defects';

import { Link } from 'react-router-dom';


import '../css/Outdoor.css';

const Home = () => {


const ecommerceData = [
  {
    title: "Product/Service Identification",
    description: "Product/Service identification refers to the process of recognizing and defining a specific product or service in the context of a business or market. It involves identifying the key features, characteristics, and value proposition of a product or service to differentiate it from competitors.",
    image: "./images/office1.webp"
  },
  {
    title: "Design Your Store",
    description: "A design store, also known as a design shop or design boutique, is a retail establishment that specializes in selling products related to design, aesthetics, and creative concepts. These stores typically offer a curated selection of merchandise that reflects a specific design style or theme.",
    image: "./images/image-and-text-1.webp"
  },
  {
    title: "Development",
    description: "Development refers to the progress and improvement of societies or communities. It encompasses aspects such as social justice, equality, human rights, education, healthcare, infrastructure, governance, and the overall well-being of individuals within a society.",
    image: "./images/image-and-text-1.webp"
  },
  {
    title: "Deployment & Maintenance",
    description: "It involves transferring the developed software from a development environment to a production environment where it can be accessed and utilized by end-users. Deployment may include tasks such as setting up servers, databases, networks, and other necessary infrastructure components.",
    image: "./images/image-and-text-1.webp"
  }
];



const BusinessNeedData = {
    title: "Serving The GTA For More Than 18 Years Maintaining High Professional Standards",
    description: "Our renowned home inspection services make sure that your dream is protected. Most new home buyers, especially first-time ones, are unaware of the various factors that determine the underlying price of a house. So, many people end up buying a nightmare instead of their dream home.",
    description2: "that their potential home is safe, structurally and mechanically sound, and does not pose any health and safety risks. A home inspection is a non-destructive visual examination of the physical structure and systems of a home (from roof to foundation) to find features that are not performing correctly or unsafe items.",
    description3: "Even newly constructed homes are known to have hidden flaws that can turn into expensive surprises. Why suffer in the long run when you can take pre-emptive action. Hire a professional home inspection team for a detailed analysis and inspection of your potential home.",
    description4: "The home inspection profession is an unregulated industry, except in British Columbia and Alberta, making your choice of a home & property inspector more difficult. Fortunately, Technominds has highly qualified inspectors who have met the requirements that allow to use of the term “Registered Home Inspector”® or “RHI”®. The registered designation identifies members of the Canadian Association of Home & Property Inspectors. We are registered inspectors and well-insured to protect you.",
    bold: "Homeownership is the most cherished dream for every Canadian.",
    bold2: "Home buyers are always eager to know.",
    bold3: "We help you avoid unwanted surprises and save you thousands of dollars in repairs.",
    bold4: "We are well Insured to protect you. We stand behind What We Inspect.",
  };


  const inspectionData = [
  {
    title: "Interiors",
    items: [
      "Walls, floor coverings, ceilings, staircases, fire and safety hazards, potential leaks"
    ]
  },
  {
    title: "Heating system",
    items: [
      "Furnace, ducting system, fireplace, base\\board heaters, and boiler"
    ]
  },
  {
    title: "Cooling system",
    items: ["A/C unit and its components"]
  },
  {
    title: "Electrical",
    items: [
      "Main panel, amperage, service line, grounding, fuses, bonding and breakers"
    ]
  },
  {
    title: "Plumbing",
    items: [
      "Water supply, waste drains, water pressure, Washrooms, laundry, kitchen plumbing"
    ]
  },
  {
    title: "Roof",
    items: [
      "Roof coverings, downspouts and gutters, roof vents, flashings, trims, skylights, Chimneys"
    ]
  },
  {
    title: "Exteriors",
    items: [
      "Walkways, doors, windows, porches, sidings, side wall venting, decks, steps, railings, driveways, Foundation wall above grade, site drainage, garage doors and openers"
    ]
  },
  {
    title: "Foundation, basement, and structure",
    items: [
      "Water leaks, Structural/Non-structural problems, seepage/ penetration into and through the foundation"
    ]
  },
  {
    title: "Attic",
    items: ["Roof structure, insulation and ventilation"]
  }
];


const torontoData = {
  title: "Toronto’s Trusted Home Inspection Services Provider",
  paragraphs: [
    "Technominds (Home & Mold) Inspection Services Inc. performs all pre-purchase inspections of real property within the prescribed Code of Ethics and “Standards of Practice”, for the Ontario Association of  Home Inspectors ‘OAHI’ and Canadian Association of Home and Property Inspectors ‘CAPHI’",
    "We offer detailed, thorough, and affordable home and property inspection services to commercial and residential customers in Ontario including Toronto, Brampton, Mississauga, and other surrounding areas. We have over 18 years of experience in checking numerous features and amenities on the premises. Our Home inspectors are TOGEL 4D highly skilled and trained in providing reliable services. We create detailed and accurate reports of your potential dream home."
  ],
  specialties: [
    "Property Inspection Services",
    "Commercial Building Inspections",
    "Newly built house inspections",
    "Post-purchase inspections",
    "Countryside Home inspections",
    "Grow house/mold inspections",
    "Environmental inspections",
    "Mold and Indoor Air Quality (IAQ) Test",
    "Pre-Listing Home Inspections for Quick Selling",
    "Infrared Thermography Inspections"
  ],
  howWeHelp: [
    "Show potential problems and repair works that need to be completed.",
    "Provide as much information as possible to help to make an enlightened decision.",
    "Provide tips on home maintenance and how to use certain systems of the home.",
    "Personal attention with professional and courteous services.",
    "Welcome further questions, to clarify our findings.",
    "Complete computer-generated reports with videos/color photos.",
    "Reports can be used for closing arguments of buying or selling.",
    "Weekdays, evenings, and weekend appointments are available."
  ]
};

const logoData = [
  "/images/logo1.png",
  "/images/logo2.png",
  "/images/logo3.png",
  "/images/logo4.png",
  "/images/logo5.png",
  "/images/logo6.png"
];


const videoData = [
  {
    url: "https://www.youtube.com/embed/FkQuawiGWUw?start=82",
    title: "Client Testimonial: Exceptional Service"
  },
  {
    url: "https://www.youtube.com/embed/FkQuawiGWUw?start=49",
    title: "Client Testimonial: Exceptional Service"
  },
  {
    url: "https://www.youtube.com/embed/FkQuawiGWUw?start=7",
    title: "Client Testimonial: Exceptional Service"
  }
];
   



const reviewData = {
  title: "Your Trusted Source for Honest Home Inspection & Review",
  paragraph: `Technominds (Home & Mold) Inspection Services team provides valuable property inspection services in Toronto, Mississauga, Brampton, and other nearby areas. Our color pictures/video reports are renowned in the Ontario real estate industry and have helped thousands of homeowners realize their dream homes. Technominds Home Inspection report is an unbiased and independent report on the actual physical systems, structures, and components of the property. Our customers expect nothing less than true professionalism, credentials, competence, and courtesy from our staff. A detailed property inspection takes around 2-3 hours and depends on the home’s square footage and age.`,
  linkText: "Learn More About Our Services",
  linkUrl: "/about-us" 
};



const additionalData = {
  title: "Additional Services",
  description:
    "Generally, home inspection is non-destructive and it’s hard to see behind the walls and ceilings. Infrared Thermography is a great option for finding hidden flaws, not visible to the naked eye. We can provide you with the best additional possible service with this latest technology in inspecting your home.",
  subTitle:
    "Benefits of Thermal Imaging:\nThermal imaging is the non-contact/non-invasive detection and very effective to inspect for:",
  benefits: [
    "Moisture Intrusion – Water Leaks",
    "Heat or Cooling loss",
    "Construction Quality",
    "Electrical Installation",
    "HVAC Installation",
    "Scan Large areas quickly",
    "Find Problems before they are visible or it’s too late."
  ],
  images: [
    "/images/a1.avif",
    "/images/a2.jpg"
  ]
};



    return (
        <div className=" common-001">
            <section className="section-banner">
                <div className="container">
                    <div className="inner-content">
                        <p>Fast, Reliable Home Inspections for Agents & Homeowners</p>
                        <h1>Comprehensive Home and Property <span>Inspections</span> for You</h1>
                        <p>
                            Discover peace of mind with our expert home inspection services, designed to meet the needs of both real estate agents and property owners. Our team ensures thorough evaluations and prompt reporting, helping you make informed decisions.
                        </p>
                        <div className="dft-btn">
                            <Link to="/contact-us" className="btn">Contact Us</Link>
                        </div>
                    </div>
                </div>
            </section>

           
            <HomeInspectionInfo />

            <Drone />

            <BusinessNeed BusinessNeedData={BusinessNeedData} />

            <Commondefects />

             <Interiors inspectionData={inspectionData} />

             <TorontoSection data={torontoData} />

             <ReasonSection logos={logoData} />

              

              <ReviewSection content={reviewData} />

              <AdditionalSection content={additionalData} />





             
        </div>
    );
};

export default Home;
